



















import Vue from "vue";
import CharacterForm from "@/components/organisms/CharacterForm.vue";
import ButtonDefault from "@/components/atoms/ButtonDefault.vue";
import ImageSelector from "@/components/molecules/ImageSelector.vue";
import { submitImage } from "@/lib/image-save";
import { callApi } from "@/lib/api";
import { showOkCancelDialog } from "@/lib/dialog";
import isMobile from "ismobilejs";

export default Vue.extend({
  components: { CharacterForm, ButtonDefault, ImageSelector },
  props: {
    novelId: String,
    characterId: String,
    character: Object,
  },
  data() {
    return {
      model: null,
      image: null,
    };
  },
  async created() {
    if (this.character) {
      const {
        character: { characterId, name, detail, additionalColumn },
        image,
      } = this;
      this.model = { characterId, name, image, detail, additionalColumn };
      return;
    }
    const GetCharacter = `
    query GetCharacter($input: GetCharacterInput!) {
      character (input: $input) {
        name
        image
        detail {
          name
          value
        }
        additionalColumn {
          name
          label
          content
        }
      }
    }
    `;
    const { novelId, characterId } = this;
    const { character } = await callApi(GetCharacter, {
      input: {
        novelId,
        characterId,
      },
    });
    this.image = character.image;
    this.model = { ...character, characterId };
  },
  computed: {
    isPC() {
      return !isMobile().any;
    },
  },
  methods: {
    change() {
      this.setModified(true);
    },
    imagePath() {
      const { novelId, characterId, image } = this;
      if (!image) return null;
      if (image.startsWith("file:")) {
        return `file:novels/${novelId}/characters/${characterId}.jpg`;
      } else if (image.startsWith("preset:")) {
        return image;
      }
      return null;
    },
    async submit() {
      const { novelId, characterId, model, image } = this;
      const UpdateCharacter = `
      mutation UpdateCharacter($input: UpdateCharacterInput!) {
        updateCharacter (input: $input) {
          novelId
          characterId
          image
          createdAt
          updatedAt
        }  
      }`;
      const { additionalColumn } = model;
      model.additionalColumn = additionalColumn.filter((item) => item.label || item.content);
      await callApi(UpdateCharacter, {
        input: {
          novelId,
          characterId,
          ...model,
          image,
        },
      });
      await submitImage(`novels/${novelId}/characters/${characterId}.jpg`);

      this.$notify({
        title: "保存しました",
        type: "success",
      });

      this.setModified(false);

      this.$router.push({
        name: "characters",
        params: { novelId, characterId },
      });
    },
    async deleteCharacter() {
      const yes = await showOkCancelDialog({
        title: "確認",
        content: "本当に登場人物を削除しますか？",
        okButton: "削除する",
      });

      if (!yes) {
        return;
      }
      const { novelId, characterId } = this;
      const Query = `
        mutation Delete($input: DeleteCharacterInput!) {
          deleteCharacter (input: $input) {
            novelId
          }
        }`;
      await callApi(Query, {
        input: {
          novelId,
          characterId,
        },
      });

      this.$notify({
        title: "削除しました",
        type: "error",
      });

      this.setModified(false);

      this.$router.push({ name: "characters" });
    },
  },
});
